// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"eecca851","498":"14458c7e","703":"d21afb7b","787":"5e13c3c2"}[chunkId] + ".chunk.js";
};